//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'
import { PoolDynamicAbi } from '@shared/Abis'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'
import { DynamicWithdrawalActivityCTO } from '@shared/sharedTypes'
import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'
import { PoolDynamic } from '@typechain-types/contracts'
import { UserConnection } from '@shared/DeploymentConfigTypes'

export const acceptDynamicRedeemRequestTx =
  (props: { activity: DynamicWithdrawalActivityCTO }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.WITHDRAW_REQUEST
    try {
      const { webSocket } = getState().chainState
      const { chainConfigurationName } = getState().chainState.chainConfiguration
      const { signer, roleEnum } = getState().chainState.userConnection as UserConnection
      if (roleEnum && chainConfigurationName) {
        assertRole(roleEnum, RoleEnum.BORROWER)

        const { activity } = props

        logOT.debug('acceptEarlyRedeemRequestSaga', activity)

        await acceptDynamicRedeemRequest(webSocket, signer as Signer, activity, chainConfigurationName)
        dispatch(poolActions.acceptEarlyRedeemRequestSuccess(props))
      }
    } catch (e: any) {
      dispatch(poolActions.acceptEarlyRedeemRequestFail(props))
      await dispatchError(dispatch, e, activity, 1016)
    }
  }

export const acceptDynamicRedeemRequest = async (
  webSocket: WebSocket | undefined,
  borrowerSigner: Signer,
  activity: DynamicWithdrawalActivityCTO,
  chainConfigurationName: string
): Promise<void> => {
  logOT.debug('acceptEarlyRedeemRequest')
  logOT.debug('acceptEarlyRedeemRequest', activity, !!borrowerSigner)
  const uuid = txUUID()
  webSocket?.send(
    wsServerActionPoolTXRequest(ActivityEnum.WITHDRAW_REQUEST, activity.poolAddr, uuid, chainConfigurationName)
  )

  const poolContract = new Contract(activity.poolAddr, PoolDynamicAbi, borrowerSigner) as unknown as PoolDynamic

  const tx = await poolContract.acceptRedemption(activity.lender, activity.uuid)

  webSocket?.send(
    wsServerActionPoolTX(
      ActivityEnum.WITHDRAW_REQUEST,
      activity.poolAddr,
      uuid,
      tx.hash as TxHash,
      chainConfigurationName
    )
  )
  await tx.wait(1)

  logOT.debug('acceptEarlyRedeemRequest tx', tx)
}
